import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../shared/shared.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { ManageCardsService } from '../manage-cards.service';
import { AbstractControl } from '@angular/forms';


@Component({
  selector: 'app-autopay-setting',
  templateUrl: './autopay-setting.component.html',
  styleUrls: ['./autopay-setting.component.css']
})
export class AutopaySettingComponent implements OnInit {
  public autopay_amount: number;
  public minimum_balance: number;
  public threshold_amount: number;
  public default_autopay_amount: number;
  public auto_pay_valid: boolean;
  public form;
  public save_btn: any;
  public is_loader: boolean;

  constructor(private fb: FormBuilder, private sharedService: SharedService, private router: Router,
    private localStorageService: LocalStorageService, private activatedRoute: ActivatedRoute,
    private manageCardsService: ManageCardsService) {
    this.sharedService.setHeaderTitle('default_page');
    this.minimum_balance = 0;
    this.autopay_amount = 0;
    this.auto_pay_valid = false;
    this.save_btn = this.sharedService.getSaveTranslation();
    this.form = fb.group({ minimumBalance: ['', Validators.required], autoPay: ['', Validators.required] }, { validator: AmountValidation.MinimumBalAmount });

    this.sharedService.getConfigConst()
      .then(res => {
        if (res.status == 'success') {
          this.threshold_amount = res.results[0]['autopayMinBalance'];
          this.default_autopay_amount = res.results[0]['autopayAmount'];
        }
      });

    this.is_loader = true;
    this.sharedService.setLoader('default_page', true);

    if (this.localStorageService.get('token') != null) {
      this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
        .then(res => {
          if (res.status === 'success' && res.isTerminated === false) {
            this.is_loader = false;
            this.sharedService.setLoader('default_page', false);

            const person = res.results[0]['personal'][0];

            // Used for dataLayer.push
            const dataLayerAccountInfo = res.results[0]['personal'];

            var dataLayerEvent = 'auto pay settings';
            (window as any).dataLayer.push({ 'event': dataLayerEvent, 'accountID': dataLayerAccountInfo[0].id.toString(), 'accountNumber': dataLayerAccountInfo[0].accountNumber.toString() });

            if(Boolean(person.isBlockAutopay).valueOf()){
              this.router.navigate(['./manage_payment_methods']);
            }
            const this_obj = this;
            this.minimum_balance = person['balThreshold'];
            this.autopay_amount = person['autoPayAmount'];
            setTimeout(function () {
              this_obj.sharedService.setHeaderUserLoggedIn('autopay_setting', true, person);
              this_obj.autoPayValidate(undefined);
            }, 10);
          } else {
            this.localStorageService.remove('token');
            this.localStorageService.set('returnUrl', 'manage_cards/autopay_settings');
            this.router.navigate(['./sign-in']);
          }
        });
    } else {
      this.localStorageService.set('returnUrl', 'manage_cards/autopay_settings');
      this.router.navigate(['./sign-in']);
    }
  }

  autoPayValidate(autopay: any) {
    if (this.minimum_balance == 0 && autopay.target.id == "minimum_balance") {
      this.minimum_balance = null;
    }
    if (this.autopay_amount == 0 && autopay.target.id == "autopay_amount") {
      this.autopay_amount = null;
    }
    if (this.minimum_balance != undefined && this.minimum_balance != null && autopay.target.id == "minimum_balance" && this.minimum_balance.toString().match(/\d\.\d/)) {
      var precision = (this.minimum_balance + "").split(".")[1].length;
      if (precision > 2) {
        this.minimum_balance = Number(Number(this.minimum_balance).toFixed(2));
      }
    }
    if (this.autopay_amount != undefined && this.autopay_amount != null && autopay.target.id == "autopay_amount" && this.autopay_amount.toString().match(/\d\.\d/)) {
      var precision = (this.autopay_amount + "").split(".")[1].length;
      if (precision > 2) {
        this.autopay_amount = Number(Number(this.autopay_amount).toFixed(2));
      }
    }

    if (this.minimum_balance >= this.threshold_amount && this.autopay_amount >= this.default_autopay_amount && this.minimum_balance !== undefined && this.autopay_amount !== undefined) {
      this.auto_pay_valid = true;

      if (autopay !== undefined) {
        if (autopay.keyCode === 13) {
          document.getElementById('btn-click-autopay').click();
        }
      }
    } else {

      this.auto_pay_valid = false;
    }
  }

  saveAutoPaySetting() {
    if (this.autopay_amount >= this.default_autopay_amount && this.minimum_balance >= this.threshold_amount) {
      this.save_btn = 'Saving...';
      this.auto_pay_valid = false;
      this.sharedService.setHeaderErrorMessage('autopay_setting', false, 'notification error', '');
      this.sharedService.setHeaderSuccessMessage('autopay_setting', false, 'Your OTP has been successfully sent.');
      this.manageCardsService.getAutoPayStatus(this.localStorageService.get('token')).then(res => {
        let data: any;
        if (res.status === 'success') {
          data = {
            'autoPayAmount': this.autopay_amount,
            'bal_threshold': this.minimum_balance,
            'token': this.localStorageService.get('token'),
            'active': res
          }

        } else {
          data = {
            'autoPayAmount': this.autopay_amount,
            'bal_threshold': this.minimum_balance,
            'token': this.localStorageService.get('token'),
            'active': res
          }
        }
        this.manageCardsService.setAutoPayThreshold(data).then(res1 => {
          this.save_btn = this.sharedService.getSaveTranslation();
          this.auto_pay_valid = true;
          window.scrollTo(0, 0);
          if (res1.status === 'success') {
            this.sharedService.setHeaderSuccessMessage('autopay_setting', true, res1.message);
            const this_obj = this;
            // setTimeout(function(){ this_obj.sharedService.setHeaderSuccessMessage('autopay_setting', false, ''); }, 3000);

          } else {
            this.sharedService.setHeaderErrorMessage('autopay_setting', true, 'notification error', res1.message);
          }
          setTimeout(() => {
            this.sharedService.setHeaderSuccessMessage('autopay_setting', false, '');
            this.router.navigate(['./manage_payment_methods']);
          }, 5000);
        });
      });
    }
  }

  ngOnInit() {
  }

}

export class AmountValidation {
  static MinimumBalAmount(AC: AbstractControl) {
    const autopay_amount = AC.get('autoPay').value; // to get value in input tag
    const minimum_balance = AC.get('minimumBalance').value; // to get value in input tag
    if (minimum_balance != undefined && minimum_balance != '') {
      if (minimum_balance < 10) {
        AC.get('minimumBalance').setErrors({ MinimumBalAmount: true })
      }
    }
    if (autopay_amount != undefined && autopay_amount != '') {
      if (autopay_amount < 20) {
        AC.get('autoPay').setErrors({ MinimumBalAmount: true })
      }
    }



  }
}



// WEBPACK FOOTER //
// ./src/app/payment/manage-cards/autopay-setting/autopay-setting.component.ts